if(!customElements.get('contact-form')) {
  class ContactForm extends HTMLElement {
  	constructor() {
      super();
      this.useKlaviyo = this.dataset.useKlaviyo=='true';
      this.querySelector('form').addEventListener('submit', this.contactFormSubmitHandler.bind(this));
      if (location.search.indexOf('customer_posted=true')>-1 && !location.hash) {
        var nearestVisibleForm = Array.from(document.querySelectorAll('[name="form_type"][value="customer"]')).map(x=>x.closest('form')).find(x=>{return $s.isVisible(x)});
        if (nearestVisibleForm) {
          $s.scrollToElement(nearestVisibleForm);
        }
      } else if (location.href.indexOf('/challenge')>-1) {
        window.addEventListener('load', ()=>{
          $s.scrollToElement(document.querySelector('main'));
        }, {once: true})
      }
    }

    getFieldLabel(elem) {
      if (elem.ariaLabel) {
        return elem.ariaLabel.trim();
      }
      if (elem.labels && elem.labels.length > 0) {
        return elem.labels[0].innerText.replace(/\*$/, '').trim();
      }
      if (elem.type == 'radio') {
        var radioGroup = elem.closest('[role="radiogroup"]');
        if (radioGroup) {
          var labelledBy = radioGroup.getAttribute('aria-labelledby');
          var groupLabel = labelledBy && document.getElementById(labelledBy);
          if (groupLabel) {
            return groupLabel.innerText.replace(/\*$/, '').trim();
          }
        }
      }
      if (elem.placeholder) {
        return elem.placeholder.trim();
      }
      return elem.name || '';
    }

    getFieldMessage(fieldLabel, isEmailFormat) {
      if (isEmailFormat) {
        return lngg.general__forms__enter_a_valid_email_message;
      }
      return lngg.general__forms__complete_the_field_message.replace(new RegExp(/{{ *field *}}/), fieldLabel);
    }

    clearFieldErrors(form) {
      form.querySelectorAll('.field-error').forEach((elem)=>{
        elem.remove();
      });
      form.querySelectorAll('.error').forEach((elem)=>{
        elem.classList.remove('error');
      });
      form.querySelectorAll('[aria-invalid="true"]').forEach((elem)=>{
        elem.removeAttribute('aria-invalid');
        var describedBy = (elem.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        var nextDescribedBy = describedBy.filter((id)=>!id.endsWith('-error'));
        if (nextDescribedBy.length) {
          elem.setAttribute('aria-describedby', nextDescribedBy.join(' '));
        } else {
          elem.removeAttribute('aria-describedby');
        }
      });
    }

    ensureFieldId(elem, index) {
      if (!elem.id) {
        elem.id = 'contact-field-' + index;
      }
      return elem.id;
    }

    setFieldError(elem, message, index) {
      var fieldId = this.ensureFieldId(elem, index);
      var errorId = fieldId + '-error';
      var errorEl = document.getElementById(errorId);

      elem.classList.add('error');
      elem.setAttribute('aria-invalid', 'true');

      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.id = errorId;
        errorEl.className = 'field-error';
        errorEl.setAttribute('role', 'alert');

        var radioGroup = elem.closest('[role="radiogroup"]');
        var checkboxField = elem.closest('.checkbox-field');
        var fieldWrap = elem.closest('.field');

        if (radioGroup) {
          radioGroup.appendChild(errorEl);
        } else if (checkboxField) {
          checkboxField.appendChild(errorEl);
        } else if (fieldWrap) {
          fieldWrap.insertAdjacentElement('afterend', errorEl);
        } else {
          elem.insertAdjacentElement('afterend', errorEl);
        }
      }

      errorEl.textContent = message;

      var describedBy = (elem.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (describedBy.indexOf(errorId) === -1) {
        describedBy.push(errorId);
        elem.setAttribute('aria-describedby', describedBy.join(' '));
      }

      if (elem.type == 'radio') {
        var form = elem.closest('form');
        if (form) {
          form.querySelectorAll('input[type="radio"][name="' + elem.name + '"]').forEach((radio)=>{
            radio.classList.add('error');
            radio.setAttribute('aria-invalid', 'true');
          });
        }
      }
    }

    contactFormSubmitHandler(e) {
      var self = this;
      var form = self.querySelector('form');
      var error = false;
      var errorMsg = form.querySelector('.error-msg');
      var invalidFields = [];
      var processedRadioNames = {};

      self.clearFieldErrors(form);
      errorMsg.style.display = 'none';
      errorMsg.innerHTML = '';

      form.querySelectorAll('.required').forEach((elem, index)=>{
        var isEmpty = elem.value == '' ||
          (elem.type == 'radio' && !form.querySelector('input[name="' + elem.name + '"]:checked')) ||
          (elem.type == 'checkbox' && !elem.checked);

        if (!isEmpty) return;

        if (elem.type == 'radio') {
          if (processedRadioNames[elem.name]) return;
          processedRadioNames[elem.name] = true;
        }

        error = true;
        var fieldLabel = self.getFieldLabel(elem);
        var message = self.getFieldMessage(fieldLabel, false);
        self.setFieldError(elem, message, index);
        invalidFields.push({elem: elem, label: fieldLabel, message: message});
      });

      if (!error) {
        var emailField = form.querySelector('.email');
        if (emailField && !$s.validateEmail(emailField.value)) {
          error = true;
          var emailLabel = self.getFieldLabel(emailField);
          var emailMessage = self.getFieldMessage(emailLabel, true);
          self.setFieldError(emailField, emailMessage, 'email');
          invalidFields.push({elem: emailField, label: emailLabel, message: emailMessage});
        }
      }

      if (error) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (invalidFields.length == 1) {
          errorMsg.textContent = invalidFields[0].message;
        } else {
          var list = document.createElement('ul');
          invalidFields.forEach((item)=>{
            var listItem = document.createElement('li');
            listItem.textContent = item.message;
            list.appendChild(listItem);
          });
          errorMsg.appendChild(list);
        }
        errorMsg.style.display = 'block';

        var firstInvalid = invalidFields[0].elem;
        if (typeof firstInvalid.focus == 'function') {
          firstInvalid.focus({preventScroll: false});
        }
        if (typeof firstInvalid.scrollIntoView == 'function') {
          firstInvalid.scrollIntoView({behavior: 'smooth', block: 'center'});
        } else if ($s.scrollToElement) {
          $s.scrollToElement(firstInvalid);
        }
        return;
      }

      var onsubmit = form.getAttribute('onsubmit');
      if (onsubmit && onsubmit.indexOf('recaptcha')>-1) {
        self.dispatchEvent(new CustomEvent('submitSuccess'));
        return true;
      }

      var params = {
        data: new FormData(form),
        success: function(data, response){
          if(response.url.includes('/challenge')) {
            form.removeEventListener('submit', self.contactFormSubmitHandler);
            form.submit();
          } else {
            form.querySelector('.form-wrap').style.display = 'none';
            form.querySelector('.success-msg').style.display = 'block';
            self.dispatchEvent(new CustomEvent('submitSuccess'));
          }
        },
        error: function(){
          form.removeEventListener('submit', self.contactFormSubmitHandler);
          form.submit();
        }
      }
      if (self.useKlaviyo) {
        params['url'] = form.dataset.ajaxSubmit;
      } else {
        params['url'] = form.getAttribute('action');
        params['type'] = 'text';
      }

      if (self.useKlaviyo  ) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $s.post(params);
      } else {
        return true;
      }
    }


  }
  customElements.define('contact-form', ContactForm);
}
